/*=============================================== ComponentsLayout styles ===============================================*/

import styled from "styled-components/macro"
import { Code } from "components/DemoItem/styles"

export const StyledCode = styled(Code)`
    border-radius: 0;
`

export const Section = styled.div`
    width: 100%;
    justify-self: normal;
`
